<template>
  <div>
    <login-after-head></login-after-head>
    <head-nav-bar></head-nav-bar>

    <div class="container mgB20">
      <div class="batch-search-page">
        <div class="search-panels">
          <div class="search-card">
            <div class="card-title-row">
              <span class="card-title">批量输入物料编码查询</span>
              <button class="icon-search-btn" @click="handleSearch" title="查询"></button>
            </div>
            <textarea
              v-model="codeInput"
              class="batch-textarea"
              placeholder="每行输入一个物料编码：
330021707323
330020604870"
            ></textarea>
          </div>

          <div class="search-card">
            <div class="card-title-row">
              <span class="card-title">批量输入物料名称查询</span>
              <button class="icon-search-btn" @click="handleSearch" title="查询"></button>
            </div>
            <textarea
              v-model="nameInput"
              class="batch-textarea"
              placeholder="请按以下格式多行输入物料名称查询：
TGB1N-63 1P C16
TGB1N-63 2P C20"
            ></textarea>
          </div>
        </div>

        <div class="action-row">
          <!-- <button class="btn-small" @click="handleAddRow">新增</button>
          <button class="btn-small" @click="handleDeleteRows">删除</button> -->
          <button class="btn-small btn-main" @click="handleSearch">查询</button>
          <!-- <button class="btn-small" @click="handleBatchAddCart">加入购物车</button> -->
          <!-- <button class="btn-small" @click="handleExport">导出</button> -->
          <span class="total-count">共 {{ tableData.length }} 条</span>
        </div>

        <div class="table-wrap">
          <table class="batch-table" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th width="50">
                  <input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll($event)" />
                </th>
                <th width="180">物料编码</th>
                <!-- <th width="120">数量</th> -->
                <th>物料名称</th>
                <th width="140">参数</th>
                <th width="80">单位</th>
                <th width="80">装箱数</th>
                <th width="100">面价</th>
                <th width="140">库存属性</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in tableData" :key="item.id">
                <td>
                  <input type="checkbox" v-model="item.checked" />
                </td>
                <td>{{ item.code || "-" }}</td>
                <!-- <td>
                  <input
                    v-model.number="item.qty"
                    class="qty-input"
                    type="number"
                    min="1"
                    @blur="normalizeQty(index)"
                  />
                </td> -->
                <td>{{ item.name || "-" }}</td>
                <td>{{ item.category || "-" }}</td>
                <td>{{ item.unit || "-" }}</td>
                <td>{{ item.packageQty || "-" }}</td>
                <td>{{ formatPrice(item.price) }}</td>
                <td>{{ item.stockAttr || "-" }}</td>
              </tr>
              <tr v-if="tableData.length === 0">
                <td colspan="8" class="empty-text">暂无查询结果，请先输入编码或名称后点击查询</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <i-footer></i-footer>
    <fixed-right></fixed-right>
  </div>
</template>

<script>
import { querySkuListBatch } from "@/api/home";

export default {
  name: "BatchSearch",
  data() {
    return {
      codeInput: "",
      nameInput: "",
      tableData: []
    }
  },
  computed: {
    isAllSelected() {
      return this.tableData.length > 0 && this.tableData.every(item => item.checked)
    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    notify(type, message) {
      if (this.$message && this.$message[type]) {
        this.$message[type](message)
        return
      }
      window.alert(message)
    },
    splitInputLines(text) {
      return (text || "")
        .split(/\r?\n/)
        .map(item => item.trim())
        .filter(Boolean)
    },
    buildResultRow(product, index) {
      return {
        id: Date.now() + index,
        checked: false,
        code: product.unique || product.code || "",
        name: product.skuName || product.name || "",
        category: product.sku || product.category || "",
        unit: product.unitName || product.unit || "只",
        packageQty: product.packageQuantity || product.packageQty || 0,
        price: product.price || 0,
        stockAttr: product.stockType || product.stockAttr || "待确认"
      }
    },
    async handleSearch() {
      const codes = this.splitInputLines(this.codeInput)
      const names = this.splitInputLines(this.nameInput)

      if (codes.length === 0 && names.length === 0) {
        this.tableData = []
        this.notify("warning", "请先输入物料编码或物料名称")
        return
      }

      try {
        const res = await querySkuListBatch({
          codeList: codes,
          nameList: names,
          page: 1,
          limit: 200
        })
        if (!res || res.status !== 200) {
          this.tableData = []
          this.notify("warning", (res && res.msg) ? res.msg : "查询失败，请稍后重试")
          return
        }
        const list = (res && res.data && res.data.skuList) ? res.data.skuList : []
        this.tableData = list.map((item, index) => this.buildResultRow(item, index))
        this.notify("success", "查询完成，共 " + this.tableData.length + " 条")
      } catch (e) {
        this.tableData = []
        this.notify("warning", "查询失败，请稍后重试")
      }
    },
    handleAddRow() {
      this.tableData.push({
        id: Date.now(),
        checked: false,
        code: "",
        name: "",
        category: "",
        unit: "只",
        packageQty: 0,
        price: 0,
        stockAttr: "待确认"
      })
    },
    handleDeleteRows() {
      const before = this.tableData.length
      this.tableData = this.tableData.filter(item => !item.checked)
      const deleted = before - this.tableData.length
      if (deleted === 0) {
        this.notify("warning", "请先勾选需要删除的行")
        return
      }
      this.notify("success", "已删除 " + deleted + " 条")
    },
    toggleSelectAll(event) {
      const checked = event.target.checked
      this.tableData = this.tableData.map(item => {
        item.checked = checked
        return item
      })
    },
    handleBatchAddCart() {
      const selected = this.tableData.filter(item => item.checked)
      if (selected.length === 0) {
        this.notify("warning", "请先勾选需要加入购物车的物料")
        return
      }
      this.notify("success", "已加入购物车 " + selected.length + " 条（演示数据）")
    },
    handleExport() {
      const exportRows = this.tableData.filter(item => item.code || item.name)
      if (exportRows.length === 0) {
        this.notify("warning", "暂无可导出的数据")
        return
      }
      this.notify("success", "导出成功（演示版，可改为后端导出）")
    },
    formatPrice(price) {
      if (price === null || price === undefined || price === "") return "-"
      return Number(price).toFixed(2)
    }
  }
}
</script>

<style scoped lang="less">
.batch-search-page {
  background: #fff;
  border: 1px solid #e5e5e5;
  padding: 16px;
}

.search-panels {
  display: flex;
  gap: 16px;
}

.search-card {
  flex: 1;
  border: 1px solid #ebebeb;
}

.card-title-row {
  height: 38px;
  padding: 0 12px;
  border-bottom: 1px solid #efefef;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  font-size: 14px;
  color: #333;
}

.icon-search-btn {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 0;
  cursor: pointer;
  background: #63c3bd;
  position: relative;
}

.icon-search-btn::before {
  content: "";
  position: absolute;
  left: 7px;
  top: 6px;
  width: 8px;
  height: 8px;
  border: 2px solid #fff;
  border-radius: 50%;
}

.icon-search-btn::after {
  content: "";
  position: absolute;
  right: 6px;
  bottom: 6px;
  width: 6px;
  height: 2px;
  background: #fff;
  transform: rotate(45deg);
}

.batch-textarea {
  width: 100%;
  min-height: 90px;
  border: 0;
  padding: 10px 12px;
  resize: vertical;
  outline: none;
  line-height: 22px;
  color: #555;
}

.action-row {
  margin: 14px 0;
  display: flex;
  align-items: center;
}

.btn-small {
  min-width: 70px;
  height: 30px;
  margin-right: 8px;
  border: 1px solid #dcdcdc;
  background: #fff;
  color: #333;
  cursor: pointer;
  border-radius: 2px;
}

.btn-main {
  color: #fff;
  border-color: #57aca7;
  background: #57aca7;
}

.total-count {
  margin-left: auto;
  color: #666;
  font-size: 14px;
}

.table-wrap {
  border: 1px solid #ececec;
}

.batch-table {
  width: 100%;
  border-collapse: collapse;
}

.batch-table th,
.batch-table td {
  height: 40px;
  border-bottom: 1px solid #ececec;
  padding: 0 10px;
  text-align: left;
  color: #4b4b4b;
}

.batch-table th {
  background: #f7f7f7;
  font-weight: 500;
}

.qty-input {
  width: 70px;
  height: 28px;
  border: 1px solid #ddd;
  text-align: center;
}

.empty-text {
  text-align: center !important;
  color: #999 !important;
}
</style>
